export const About = () => {
  return (
    <div className="about">
      <span className="about-heading animate__zoomIn">About App</span>
      <p className="about-details">
      Welcome to our Quiz App!
Test your tech knowledge with 10 exciting questions designed to challenge your skills and expand your understanding. Whether you're a tech enthusiast, a student, or just curious about technology, this app is perfect for you.

Our quiz covers a wide range of topics, from the history of computers to the latest advancements in artificial intelligence and machine learning. The questions are crafted to be both fun and informative, helping you learn while enjoying the experience.

Using our app is easy! Simply select your answers from the multiple-choice options and submit your response. You'll receive instant feedback, including an explanation of the correct answer to help you learn as you go.

Start your journey today and see how much you know—or discover something new! Dive in, have fun, and challenge yourself with our tech quiz.
      </p>
    </div>
  );
};
